import {
  IS_LOGIN,
  IS_LOGOUT,
  SHOW_LOADING,
  HIDE_LOADING,
  PERSIST_AUTH,
  CLEAR_STORE,
  LOGIN_ERROR,
  CLEAR_LOGIN_ERROR,
} from "../actions/types";

let authState = sessionStorage.getItem("token");
let isAdmin = sessionStorage.getItem("isAdmin");
let analyst_id = sessionStorage.getItem("analyst_id");
let analystName = sessionStorage.getItem("analystName");
let accountRole = sessionStorage.getItem("accountRole");
let tabsAccessible = sessionStorage.getItem("tabsAccessible");
const INITIAL_STATE = {
  token: authState,
  loading: false,
  analyst_id: analyst_id,
  isAdmin: isAdmin && JSON.parse(isAdmin)?.status,
  analystName: analystName,
  accountRole: accountRole,
  tabsAccessible: tabsAccessible && JSON.parse(tabsAccessible)?.tabs,
  login_error: false,
  isAuthenticated: authState !== null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IS_LOGIN:
      return {
        ...state,
        isAuthenticated: true,
        analyst_id: action.payload,
        isAdmin: action.isAdmin,
        token: action.token,
        analystName: action.analystName,
        accountRole: action.accountRole,
        tabsAccessible: action.tabsAccessible,
        loading: false,
        login_error: false,
      };
    case IS_LOGOUT:
      return {
        token: null,
        isAuthenticated: false,
        loading: false,
        analyst_id: null,
        login_error: false,
      };
    case LOGIN_ERROR:
      return { ...state, login_error: true };
    case CLEAR_LOGIN_ERROR:
      return { ...state, login_error: false };
    case PERSIST_AUTH:
      return { ...state, isAuthenticated: true, login_error: false };
    case CLEAR_STORE:
      return {
        isAuthenticated: false,
        loading: false,
        analyst_id: null,
        login_error: false,
      };
    case SHOW_LOADING:
      return { ...state, loading: true };
    case HIDE_LOADING:
      return { ...state, loading: false };
    default:
      return state;
  }
};
